/* eslint-disable no-useless-catch */
import {
  exportBulkReportOutput,
  exportManufacturingOrder,
  getAllMO,
  getOneMO,
  IExportBulkReportRequest,
} from '@/apis/moAPI'
import errorHandler from '@/utils/errorHandler'

import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import {
  CLEAR_MANUFACTURING_ORDERS,
  EXPORT_BULK_REPORT_OUTPUT,
  EXPORT_MANUFACTURING_ORDER,
  FETCH_MANUFACTURING_ORDER_DETAIL,
  FETCH_MANUFACTURING_ORDERS,
  SET_MO_LOADING,
} from './actions'

type TMOState = {
  manufacturingOrders: IManufacturingPlan[]
  manufacturingOrderDetail: IManufacturingPlan | null
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    manufacturingOrders: [],
    manufacturingOrderDetail: null,
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_MANUFACTURING_ORDERS]: (
      state: TMOState,
      payload: {
        manufacturingPlans: IManufacturingPlan[]
        totalRecords: number
      }
    ) => {
      state.manufacturingOrders = payload.manufacturingPlans
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [FETCH_MANUFACTURING_ORDER_DETAIL]: (state: TMOState, payload: IManufacturingPlan) => {
      state.manufacturingOrderDetail = payload
    },
    [CLEAR_MANUFACTURING_ORDERS]: (state: TMOState) => {
      state.manufacturingOrders = []
      state.manufacturingOrderDetail = null
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_MO_LOADING]: (state: TMOState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_MANUFACTURING_ORDERS]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        filter?: string
        sort?: string
        orderNumber?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_MO_LOADING, true)
        const { page = 1, limit = 10, filter = '', sort = '', orderNumber = '', sortBy, sortType } = payload
        const response = await getAllMO(page, limit, filter, sort, orderNumber, sortBy, sortType)
        commit(FETCH_MANUFACTURING_ORDERS, {
          manufacturingPlans: response.manufacturingPlans,
          totalRecords: response.totalRecords,
        })
        return response
      } catch (err) {
        commit(SET_MO_LOADING, false)
        errorHandler(err, {}, true)
        throw err
      }
    },
    [EXPORT_MANUFACTURING_ORDER]: async (
      { commit }: { commit: Function },
      payload: {
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_MO_LOADING, true)
        const data = {
          ...(payload.sortBy && { sortBy: payload.sortBy }),
          ...(payload.sortType && { sortType: payload.sortType }),
        }
        const response = await exportManufacturingOrder(data)
        commit(SET_MO_LOADING, false)
        return response
      } catch (err) {
        commit(SET_MO_LOADING, false)
        throw err
      }
    },
    [FETCH_MANUFACTURING_ORDER_DETAIL]: async ({ commit }: { commit: Function }, orderId: string) => {
      try {
        commit(SET_MO_LOADING, true)
        const detail = await getOneMO(orderId)
        commit(FETCH_MANUFACTURING_ORDER_DETAIL, detail)
        return detail
      } catch (err) {
        errorHandler(err, {}, true)
        throw err
      } finally {
        commit(SET_MO_LOADING, false)
      }
    },
    [CLEAR_MANUFACTURING_ORDERS]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_MANUFACTURING_ORDERS)
    },
    [EXPORT_BULK_REPORT_OUTPUT]: async ({ commit }: { commit: Function }, payload: IExportBulkReportRequest) => {
      try {
        commit(SET_MO_LOADING, true)
        await exportBulkReportOutput(payload)
        commit(SET_MO_LOADING, false)
      } catch (err) {
        commit(SET_MO_LOADING, false)
        throw err
      }
    },
  },
  getters: {
    getMOItems: (state: TMOState) => state.manufacturingOrders,
    getManufacturingOrderDetail: (state: TMOState) => state.manufacturingOrderDetail,
    getTotalRecords: (state: TMOState) => state.totalRecords,
    isMOLoading: (state: TMOState) => state.isLoading,
    isLoaded: (state: TMOState) => state.isLoaded,
  },
}
